var _effectorFileName = "/src/shared/components/language-switcher/language-switcher.tsx";
import { useRouter } from 'next/router';
import { CheckIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'next-i18next';
import { IoLanguageOutline } from 'react-icons/io5';
import { Button } from '@/shared/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/shared/components/ui/dropdown-menu';
import { DEFAULT_LOCALE, LOCALES, type Locale } from '@/shared/config/i18n';
import { cn } from '@/shared/lib/cn';
import { saveLocalePreference } from '@/shared/lib/locale-storage';
const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  ru: 'Русский'
};
interface LanguageSwitcherProps {
  className?: string;
}
export const LanguageSwitcher = ({
  className
}: LanguageSwitcherProps) => {
  const router = useRouter();
  const {
    t
  } = useTranslation('common');
  const currentLocale = (router.locale ?? DEFAULT_LOCALE) as Locale;
  const handleLocaleChange = (locale: Locale) => {
    if (locale === currentLocale) return;

    // Save preference to cookie and localStorage
    saveLocalePreference(locale);

    // router.asPath is already without locale prefix
    const path = router.asPath;

    // Build new URL: default locale has no prefix, others have /{locale} prefix
    const newUrl = locale === DEFAULT_LOCALE ? path : `/${locale}${path}`;

    // Force full page reload to trigger SSR with new locale
    window.location.href = newUrl;
  };
  return <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon" className={className} aria-label={t('languageSwitcher.buttonLabel')}>
          <IoLanguageOutline className="h-5 w-5" />
          <span className="sr-only">{t('languageSwitcher.buttonLabel')}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {LOCALES.map(locale => <DropdownMenuItem key={locale} onClick={() => handleLocaleChange(locale)} className={cn('cursor-pointer gap-2')} aria-current={currentLocale === locale ? 'true' : undefined}>
            <CheckIcon className={cn('h-4 w-4', currentLocale === locale ? 'opacity-100' : 'opacity-0')} />
            {LOCALE_NAMES[locale]}
          </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>;
};